import React from 'react'

import S from 'utils/sentences'

import CKEditor from 'components/elements/CKEditor'
import CenteredLoader from 'components/lib/CenteredLoader'
import Button from 'components/lib/DesignSystem/Button'

class AnnouncementLogo extends React.Component {
  state = {
    editorSourceModeEnabled: false,
  }

  componentDidMount() {
    const { isGroupSettings, data } = this.props
    if (!isGroupSettings) this.props.getAnnouncementsLogo()
    else {
      this.props.updateAnnouncementsLogo(
        data?.notificationsLogoTemplate || data?.defaultNotificationsLogoTemplate
      )
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (!nextProps.loader && this.props.loader && !this.props.notificationsLogoTemplate) ||
      JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)
    ) {
      this.props.updateAnnouncementsLogo(
        nextProps.data?.notificationsLogoTemplate ||
          nextProps.data?.defaultNotificationsLogoTemplate
      )
    }
  }

  handleChangeInput = (value) => this.props.updateAnnouncementsLogo(value)

  handleRestoreDefault = () => {
    this.props.updateAnnouncementsLogo(this.props.data.defaultNotificationsLogoTemplate)
  }

  render() {
    const { editorSourceModeEnabled } = this.state
    const { data, loader, permissions, isGroupSettings, isStaticSalesDemo } = this.props

    return (
      <div className="pr">
        {!loader ? (
          <>
            <CKEditor
              id="announcement-logo"
              value={data.notificationsLogoTemplate || data.defaultNotificationsLogoTemplate}
              onChange={this.handleChangeInput}
              configuration="logo"
              onSourceModeToggle={(value) => this.setState({ editorSourceModeEnabled: value })}
              activeUpdateMode
            />
            <div className="announcement-actions">
              <Button
                id="Settings_End_User_Alerts_Restore_Default"
                text="Restore Default"
                styleType="tertiary"
                className={isGroupSettings ? '' : 'mr'}
                onClick={this.handleRestoreDefault}
                disabled={
                  !permissions.admin ||
                  isStaticSalesDemo ||
                  data.notificationsLogoTemplate === data.defaultNotificationsLogoTemplate
                }
              />
              {!isGroupSettings && (
                <Button
                  id="emailNotifications-customLogo-update"
                  text="Update"
                  onClick={this.props.submitAnnouncementsLogo}
                  disabled={
                    !data.notificationsLogoTemplate ||
                    isStaticSalesDemo ||
                    editorSourceModeEnabled ||
                    !permissions.admin
                  }
                  popup={
                    editorSourceModeEnabled && {
                      position: 'topRight',
                      text: S.DISABLE_SOURCE_MODE,
                    }
                  }
                />
              )}
            </div>
          </>
        ) : (
          <CenteredLoader overlap />
        )}
      </div>
    )
  }
}

export default AnnouncementLogo
